<script lang="ts">
  // BJL-CHECK: Button (used) — a bjl icon-only Button, positioned by the caller.
  //
  // Small ✕ pinned to the top-right corner of a favorited item. The parent must be
  // position: relative; `top`/`right` nudge the button for badge vs card layouts.
  import { Button } from '@byjackli-labs/ui/Button'
  import { Colors } from '../../ui/colors'

  interface Props {
    onRemove: () => void
    top?: number
    right?: number
  }

  const { onRemove, top = -5, right = -5 }: Props = $props()
</script>

<Button
  variant="secondary"
  size="sm"
  iconOnly
  aria-label="Remove favorite"
  onclick={(e: MouseEvent) => {
    e.stopPropagation()
    onRemove()
  }}
  style="
    position: absolute; top: {top}px; right: {right}px; z-index: 1;
    width: 20px; height: 20px; min-width: 20px; min-height: 20px;
    padding: 0; border-radius: 10px; font-size: 10px; line-height: 1;
    color: {Colors.textMuted};
  "
>✕</Button>
